// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"8f7c16abfcc4d24361eb","293":"68f483ede9dc28e71b1e"}[chunkId] + ".js";
};